import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getAdMarketPublishGroupCode, IsPremiumConsumerUser, IsChildConsumerUser, } from './sharedAdsUtils';
export var BING_SUPPORTED_MARKETS = ['en-us', 'en-gb', 'en-ca', 'en-au'];
var PREBID_APPNEXUS_SUPPORTED_MARKETS = [
    'ar-sa',
    'ar-ae',
    'ar-eg',
    'da-dk',
    'de-at',
    'de-ch',
    'de-de',
    'el-gr',
    'en-ae',
    'en-ar',
    'en-at',
    'en-au',
    'en-br',
    'en-ca',
    'en-ch',
    'en-cl',
    'en-co',
    'en-de',
    'en-dk',
    'en-eg',
    'en-fi',
    'en-gb',
    'en-gr',
    'en-hk',
    'en-id',
    'en-ie',
    'en-in',
    'en-mx',
    'en-my',
    'en-nl',
    'en-no',
    'en-nz',
    'en-pe',
    'en-ph',
    'en-pl',
    'en-pt',
    'en-ru',
    'en-sa',
    'en-se',
    'en-sg',
    'en-th',
    'en-tr',
    'en-us',
    'en-vn',
    'en-za',
    'es-ar',
    'es-cl',
    'es-co',
    'es-cr',
    'es-do',
    'es-ec',
    'es-es',
    'es-gt',
    'es-mx',
    'es-pe',
    'es-us',
    'es-ve',
    'fi-fi',
    'fil-ph',
    'fr-be',
    'fr-ca',
    'fr-ch',
    'fr-fr',
    'id-id',
    'it-it',
    'ja-jp',
    'ko-kr',
    'ms-my',
    'nb-no',
    'nl-be',
    'nl-nl',
    'pl-pl',
    'pt-br',
    'pt-pt',
    'ru-ru',
    'sv-se',
    'th-th',
    'tr-tr',
    'vi-vn',
    'zh-cn',
    'zh-hk',
    'zh-sg',
    'zh-tw',
];
var nativeAdUserFlight;
var isCurrentUserOnNativeAdAllInboxFlight;
var isCurrentUserOnNativeAdOtherOnlyFlight;
function calculateAdFlightForUser() {
    if (IsPremiumConsumerUser() || IsChildConsumerUser()) {
        return 0 /* NoNativeAd */;
    }
    var userMarket = getAdMarketPublishGroupCode();
    if (!userMarket) {
        return 0 /* NoNativeAd */;
    }
    // In the ideal situation, native ads flights should not overlap on a single user
    // However, in the real situation, we need to prepare what to do if two flight is overlapped on a single user
    // The evaluation order is
    // Bing flight will be evaluated before the Prebid flight as Bing flight is a smaller scope
    // AllInbox flight will be evaluated before the Other Inbox only flight as Other Inbox only flight is an expermental flight
    // The final flight information needs to be the same as the native ad store to prevent one situation that we evaluate a user as one flight but load another flight for him later
    if (isMailFeatureEnabled('fwk-nativeAds-bingTwoClick') &&
        BING_SUPPORTED_MARKETS.indexOf(userMarket) > -1) {
        return 2 /* BingTwoClickAllInbox */;
    }
    if (isMailFeatureEnabled('fwk-nativeAds-bingOneClick') &&
        BING_SUPPORTED_MARKETS.indexOf(userMarket) > -1) {
        return 1 /* BingOneClickAllInbox */;
    }
    if (isMailFeatureEnabled('fwk-nativeAds-bingTwoClickOtherInboxOnly') &&
        BING_SUPPORTED_MARKETS.indexOf(userMarket) > -1) {
        return 4 /* BingTwoClickOtherOnly */;
    }
    if (isMailFeatureEnabled('fwk-nativeAds-bingOneClickOtherInboxOnly') &&
        BING_SUPPORTED_MARKETS.indexOf(userMarket) > -1) {
        return 3 /* BingOneClickOtherOnly */;
    }
    if (isMailFeatureEnabled('fwk-nativeAds-prebidOneClickAllInbox') &&
        PREBID_APPNEXUS_SUPPORTED_MARKETS.indexOf(userMarket) > -1) {
        return 5 /* PrebidOneClickAllInbox */;
    }
    if (isMailFeatureEnabled('fwk-nativeAds-prebidOneClickOtherInboxOnly') &&
        PREBID_APPNEXUS_SUPPORTED_MARKETS.indexOf(userMarket) > -1) {
        return 6 /* PrebidOneClickOtherOnly */;
    }
    if (isMailFeatureEnabled('fwk-nativeAds-appNexusOneClick') &&
        PREBID_APPNEXUS_SUPPORTED_MARKETS.indexOf(userMarket) > -1) {
        return 7 /* AppNexusOneClickAllInbox */;
    }
    if (isMailFeatureEnabled('fwk-nativeAds-appNexusOneClickOtherInboxOnly') &&
        PREBID_APPNEXUS_SUPPORTED_MARKETS.indexOf(userMarket) > -1) {
        return 8 /* AppNexusOneClickOtherOnly */;
    }
    return 0 /* NoNativeAd */;
}
export function getNativeFinalFlightForUser() {
    // We must calculate the native Ad final flight assigned to a particular user due to the complextity of the native Ad flight. It is not a simple true/false decision
    // We are trying to calculate the native Ad final flight used to determine to be loaded in MailList and NativeAdStore later. This is avoid multiple calculation in a single user session
    // The native Ad flight will never change including enabled or not during one OWA session.
    // Cache the value so that we do not need to calucuate this again and again
    if (typeof nativeAdUserFlight != 'undefined') {
        return nativeAdUserFlight;
    }
    nativeAdUserFlight = calculateAdFlightForUser();
    return nativeAdUserFlight;
}
export function isNativeAdsAllInboxFlightOn() {
    if (typeof isCurrentUserOnNativeAdAllInboxFlight != 'undefined') {
        return isCurrentUserOnNativeAdAllInboxFlight;
    }
    var currentUserAdFlight = getNativeFinalFlightForUser();
    isCurrentUserOnNativeAdAllInboxFlight =
        currentUserAdFlight == 7 /* AppNexusOneClickAllInbox */ ||
            currentUserAdFlight == 1 /* BingOneClickAllInbox */ ||
            currentUserAdFlight == 2 /* BingTwoClickAllInbox */ ||
            currentUserAdFlight == 5 /* PrebidOneClickAllInbox */;
    return isCurrentUserOnNativeAdAllInboxFlight;
}
export function isNativeAdsOtherInboxOnlyFlightOn() {
    if (typeof isCurrentUserOnNativeAdOtherOnlyFlight != 'undefined') {
        return isCurrentUserOnNativeAdOtherOnlyFlight;
    }
    var currentUserAdFlight = getNativeFinalFlightForUser();
    isCurrentUserOnNativeAdOtherOnlyFlight =
        currentUserAdFlight == 8 /* AppNexusOneClickOtherOnly */ ||
            currentUserAdFlight == 3 /* BingOneClickOtherOnly */ ||
            currentUserAdFlight == 4 /* BingTwoClickOtherOnly */ ||
            currentUserAdFlight == 6 /* PrebidOneClickOtherOnly */;
    return isCurrentUserOnNativeAdOtherOnlyFlight;
}
// This is only used for test
export function setNativeAdUserFlightValue(value) {
    nativeAdUserFlight = value;
}
//# sourceMappingURL=nativeAdsUtils.js.map